<template>
  <component is="div">

    <div v-if="typeof beads == 'object'"
         v-for="i in limit"
         :key="i"
    >{{ beads[i - 1] }}
    </div>

    <div v-else
    >{{ beads }}
    </div>

  </component>

</template>

<script>
export default {
  props: {
    deck: {
      type: String,
      required: true,
      validator: function (val) {
        return _.includes(['upper', 'lower'], val);
      }
    },

    rod: {
      type: Number,
      required: true
    }
  },

  data: function () {
    return {
      clearPointer: null
    };
  },

  watch: {
    events: function (fresh, stale) {
      switch (fresh) {
        case 'recorded.miss':
        case 'recorded.hit':
        case 'game.lost':
        case 'game.new':
          this.$emit('obsoleteDeckRod', {deck: this.deck, rod: this.rod});
          break;
      }
    },

    beads: function (fresh, stale) {

      if (!_.isEqual(fresh, stale)) {
        let direction = (_.sum(fresh) > _.sum(stale))
            ? 'increase' : 'decrease';

        let i, j;

        try {
          switch (direction) {
            case 'increase':
              for (i in fresh) {
                i = i * 1;
                j = i + 1;

                if (!_.isUndefined(fresh[j]) && fresh[i] == fresh[j]) {
                  if ((fresh[j] + 1) <= this.limit) {
                    fresh[j]++;
                  } else {
                    throw new Error(direction);
                  }
                }
              }
              break;

            case 'decrease':
              for (i in fresh) {
                i = i * 1;
                j = i + 1;

                if (!_.isUndefined(fresh[j]) && fresh[i] == fresh[j]) {
                  if ((fresh[j] - 1) >= 0) {
                    fresh[j]--;
                  } else {
                    throw new Error(direction);
                  }
                }
              }
              break;
          }
        } catch (e) {

          switch (direction) {
            case 'increase':
              i = fresh.length - 1;
              j = i - 1;
              while (fresh[i] == fresh[j]) {
                fresh[j]--;
                i = i - 1;
                j = j - 1;
              }
              break;

            case 'decrease':
              i = 0;
              j = i + 1;
              while (fresh[i] == fresh[j]) {
                fresh[j]++;
                i = i + 1;
                j = j + 1;
              }
              break;
          }
        }

      }
    }
  },

  computed: {
    events: function () {
      return this.$read('events');
    },
    limit: function () {
      let upper = this.$read('prefs.abacus.upperRod').length;
      let lower = this.$read('prefs.abacus.lowerRod').length;
      return {upper, lower}[this.deck];
    },

    beads: function () {
      let targ = 'abacus.'
          .concat(this.deck)
          .concat('.')
          .concat(this.rod - 1);

      return this.$read(targ);
    }
  }
}
</script>

<style scoped>

</style>